import React, { useEffect, useRef, useState } from 'react'
import tick from "./icons/tick.svg";
import close from "./icons/close.svg";
import styles from "./CustomFieldData.module.css"
import edit from "./icons/edit.svg"
import { notify } from '../notification/Notification';
import { Failure } from '../notification/templates';
import API from '../utils/API';
import Select from '../select';
import DateOnlyPicker from '../date-only-picker/DateOnlyPicker';
import { toValidDate } from '../date-only-picker/DateOnlyPicker';

const ShowAndEditContent = ({content,dataType,accessor,entityId}) => {
    const boolean="BOOLEAN";
    const numeric="NUMERIC";
    const alphaNumeric="ALPHA_NUMERIC";
    const date="DATE";
    const file="FILE_UPLOAD";

    const replaceIfNull=(content)=>{
        if(content==="--")
        {
            if(dataType===numeric)
                return ""
            if(dataType===alphaNumeric)
                return ""
        }
        else
            return content;
    }
    const [value,setValue]=useState(replaceIfNull(content));
    const [lastSaved,setLastSaved]=useState(null);
    const [onEdit,setOnEdit]=useState(false);
    const [onHover,setOnHover]=useState(false);

    useEffect(()=>{
        setValue(lastSaved ? lastSaved : content);
    },[onEdit])

    const containerRef = useRef(null);

    const iconStyle={width:"15px",height:"15px",cursor:"pointer"}

    const handleClose=()=>{
        setTimeout(()=>{
            setOnEdit(false);
            setOnHover(false);
        },400)
    }

    const handleSave=async(val=null)=>{
        const reqData={
            value: val ? val : value,
            entityId
        }
        try
        {
            const response=await API.post(`/custom-fields/${accessor}/values`,reqData)
            if (response.status.success)
            {
                setLastSaved(response.body.value);    
                handleClose();
            }
            else
                notify(<Failure>Error in saving the data in the custom field</Failure>)
        }
        catch(error)
        {
            console.error(error)
            notify(<Failure>Unexpected error in saving the data in the custom field</Failure>)
        }
    }

    const handSaveForDateBoolean=(value)=>{
        setValue(value);
        handleSave(value);
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if ( containerRef.current && !containerRef.current.contains(event.target))
                handleClose();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    //utitilities for input numeric
    const handleNumericChange = (e) => {
        let value = e.target.value;
        if (!/^\d*$/.test(value))
            return;
        if (value === "") 
        {
            setValue("0");
            return;
        }
        value = value.replace(/^0+(?=\d)/, "");
        setValue(value);
    };

    //utilities for input alpha numeric
    const handleAlphaNumericChange = (e) => {
        const value = e.target.value;
        if (!/^[a-zA-Z0-9 ]*$/.test(value))
            return;
        setValue(value);
    };

    //utilities for input boolean
    const optionsForBoolean = [
        {
            text: "true",
            key: "true",
        },
        {
            text: "false",
            key: "false",
        }
    ];
    const optionsMapForBoolean = Object.fromEntries(
        optionsForBoolean.map(({ text, key }) => [text, key])
    );
    const findActive = (options, target) => {
        return options.findIndex(
            (item) => item.key === target
        );
    };

    return (
        <div ref={containerRef}>
            {onEdit ? (
                <div className={styles.cell}>
                    {(!dataType) && (
                        "No datatype sent"
                    )}

                    {(dataType===numeric) && (
                        <input 
                            value={value} 
                            onChange={handleNumericChange}
                            style={{width:"80%"}}
                        />
                    )}

                    {(dataType===alphaNumeric) && (
                        <input 
                            value={value} 
                            onChange={handleAlphaNumericChange}
                            style={{width:"80%"}}
                        />
                    )}

                    {(dataType===boolean) && (
                        <Select
                            active={findActive(optionsForBoolean,String(value))}
                            options={optionsForBoolean.map((item)=>item.text)}
                            triggerProps={{
                                className: styles.dropdown
                            }}
                            onOptionSelect={
                                (option,index)=>handSaveForDateBoolean(optionsMapForBoolean[option])
                            }
                        />
                    )}

                    {(dataType===date) && (
                        <DateOnlyPicker
                            value={value}
                            onChange={(date)=>handSaveForDateBoolean(toValidDate(date))}
                        />
                    )}

                    {(dataType===file) && (
                        <div>File Upload not implemented</div>
                    )}

                    {(dataType===numeric || dataType===alphaNumeric) && (
                        <img 
                            src={tick} 
                            style={iconStyle} 
                            onClick={()=>handleSave()}
                            title="Save"
                        />
                    )}
                    <img 
                        src={close} 
                        style={iconStyle} 
                        onClick={()=>handleClose()}
                        title="Close"
                    />
                </div> ) :

                <div 
                    className={styles.cell}
                    onMouseOver={() => setOnHover(true)}
                    onMouseLeave={() => setOnHover(false)}
                >
                    <span className={styles.cellText}>
                        {lastSaved ? lastSaved : content}
                    </span>

                    {onHover && (
                        <img 
                            src={edit} 
                            className={styles.editIcon}
                            onClick={() => setOnEdit(true)}
                            title="Edit"
                        />
                    )}
                </div>
            }
        </div>
    )
}

export default ShowAndEditContent